<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { incomeExpenseReportService } from "../../../../services/reportservice/incomeexpensereport.service.js";
import Select from "@/components/c-select";
import Input from "@/components/c-input";
import Button from "@/components/c-button";
import moment from 'moment'

/* eslint-disable no-console */
export default {
  page: {
    title: "Income && Expense Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Input,
    Select 
  },
  data() {
    return {
      title: "Income && Expense Report",
      data: [],
      date: '',
      projects: {},
      summary: {},

      dataStartDate: '',
      dataEndDate: '',
      dataProjectId: 0,
      user: JSON.parse(localStorage.getItem('user')),
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData();
    
  },
  methods: {
    
     
    loadingData: function() {
      
      this.fetchingStats = false;
      incomeExpenseReportService.getIncomeExpense()
        .then(response => {
          this.data = response.data.result;
          this.date = response.data.date;
          this.dataStartDate = response.data.date.start_date;
          this.dataEndDate = response.data.date.end_date;
          this.projects = response.data.project;
        });
    },

    submitSearch: function() {
      let data = '?project_id='+this.dataProjectId+'&start_date='+this.dataStartDate+'&end_date='+this.dataEndDate
      incomeExpenseReportService.getIncomeExpense(data)
        .then(response => {
          this.data = response.data.result;
          this.date = response.data.date;
          this.dataStartDate = response.data.date.start_date;
          this.dataEndDate = response.data.date.end_date;
          this.projects = response.data.project;
      });
    },

    formatCurrency(value) {
      if(value == 0 ){
        return '';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    print() {
      window.print();
    }
  },
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.income_expense.text')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row">
              
              <div class="col-sm-2">
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.projects}"
                  v-model="dataProjectId"
                /> 
              </div>
              <div class="col-sm-2">
                <Input 
                  :type="'date'"
                  :id="'start_date'"
                  v-model="dataStartDate"
                /> 
              </div>
              <div class="col-sm-2">
                <Input 
                  :type="'date'"
                  :id="'end_date'"
                  v-model="dataEndDate"
                /> 
              </div>
              <div class="col-sm-2">
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
                <td width="21%"><p>&nbsp;</p></td>
                <td width="20%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 092 685 009 | 098 685 009 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <p class=""><u>{{$t('report.income_expense.text')}}</u></p>
                    <p class=""><u>ប្រចាំខែ: {{this.dateFormat(date.start_date)}} - {{this.dateFormat(date.end_date)}}</u></p>
                    <p class=""><u>គម្រោង:</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
            <table class="content-general h8 project-sumary-table" width="100%">
              
                <tr class="thead">
                  <th>{{$t('report.income_expense.date')}}</th>
                  <th>{{$t('report.income_expense.invoice')}}</th>
                  <th>{{$t('report.income_expense.name')}}</th>
                  <th>{{$t('report.income_expense.room')}}</th>
                  <th>{{$t('report.income_expense.code')}}</th>
                  <th>{{$t('report.income_expense.transaction-type')}}</th>
                  <th>{{$t('report.income_expense.description')}}</th>
                  <th>{{$t('report.income_expense.income')}}</th>
                  <th>{{$t('report.income_expense.expense')}}</th>
                  <!-- <th>{{$t('report.income_expense.continue-total')}}</th> -->
                  <!-- <th>{{$t('report.income_expense.balance')}}</th> -->
                  <!-- <th>{{$t('report.income_expense.other')}}</th> -->
                  <!-- <th>{{$t('report.income_expense.cash')}}</th> -->
                
                </tr>
               
              <tbody>
                <tr v-for="(list, index) in data" :key="index">
                  <!-- <td>{{index + 1}}</td> -->
                  <td>{{list.transaction_date}}</td>
                  <td>{{list.invoice_code}}</td>
                  <td>{{list.customer_name}}</td>
                  <td>{{list.property_code}}</td>
                  <td>N/A</td>
                  <td>
                    {{
                      list.transaction_type==1?"Income": 
                      list.transaction_type==2?"Expense":
                      list.transaction_type==3?"Payment Income":
                      "Booking Income"
                    }}
                  </td>
                  <td>{{list.notation}}</td>
                  <td>{{(list.transaction_type!=2)?formatCurrency(list.amount):''}}</td>
                  <td>{{(list.transaction_type==2)?formatCurrency(list.amount):''}}</td>
                </tr>
              </tbody>
            </table>
            <br>
            <!-- <table width="100%">
              <tr>
                <td width="60%">&nbsp;</td>
                <td width="30%" style="text-align:right">
                  <p class="enb h6" style="color:red">Total:</p>
                </td>
                <td width="10%">
                  <p class="enb h6" style="color:red">{{formatCurrency(data.total_price)}}</p>
                </td>
              </tr>

              <tr>
                <td width="60%">&nbsp;</td>
                <td width="30%" style="text-align:right">
                  <p class="enb h6" style="color:red">Total Unit:</p>
                </td>
                <td width="10%">
                  <p class="enb h6" style="color:red">{{data.total_unit}}</p>
                </td>
              </tr>

              <tr>
                <td width="60%">&nbsp;</td>
                <td width="30%" style="text-align:right">
                  <p class="enb h6" style="color:red">Total Sold:</p>
                </td>
                <td width="10%">
                  <p class="enb h6" style="color:red">{{data.total_sold}}</p>
                </td>
              </tr>

              <tr>
                <td width="60%">&nbsp;</td>
                <td width="30%" style="text-align:right">
                  <p class="enb h6" style="color:red">Total Remaining:</p>
                </td>
                <td width="10%">
                  <p class="enb h6" style="color:red">{{data.total_remaining}}</p>
                </td>
              </tr>
            </table> -->
          </div>
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>